var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1114_5793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0C25.3137 2.57702e-07 28 2.68629 28 6V22C28 25.3137 25.3137 28 22 28H6C2.68629 28 3.22139e-08 25.3137 0 22V6C2.57711e-07 2.68629 2.68629 3.22128e-08 6 0H22ZM5.83301 5.83301L12.2012 14.876L5.83301 22.167H7.19434L12.8691 15.7939L17.3916 22.167H22.167L15.5664 12.7637L21.6133 5.83301H20.1826L14.9414 11.7998L14.8105 11.708L10.6553 5.83301H5.83301ZM10.0547 6.91016L20.0908 21.0898H17.9219C14.8241 16.5713 11.5581 12.1441 8.42578 7.64258C8.26153 7.40656 8.07971 7.1695 7.95605 6.91016H10.0547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1833 5.8335H21.6136L15.5671 12.764L22.1673 22.1669H17.3919L12.8698 15.7946L7.1951 22.1669H5.83398L12.2017 14.8761L5.83398 5.8335H10.6555L14.8113 11.7081L14.9419 11.7997L20.1833 5.8335ZM20.091 21.0899L10.0557 6.91042H7.9564C8.08005 7.16978 8.26184 7.4067 8.42609 7.64273C11.5585 12.1443 14.8247 16.5713 17.9225 21.0899H20.091Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1114_5793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXImage);
export default __webpack_public_path__ + "static/media/x-image.71a1eff5cc03f201e332d617684522ad.svg";
export { ForwardRef as ReactComponent };